import { render, staticRenderFns } from "./PanImageActivity.vue?vue&type=template&id=0b837ad5&scoped=true&"
import script from "./PanImageActivity.vue?vue&type=script&lang=js&"
export * from "./PanImageActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b837ad5",
  null
  
)

export default component.exports